<div class="cat__footer" style="margin-bottom: 20px;">
    <div class="cat__footer__top">
        <div class="cat__pages__login__footer">

        </div>
    </div>
    <!-- sjaslow: I didn't like this, gets in the way of the UI.
      <a href="javascript: void(0);" class="cat__core__scroll-top" onclick="$('body, html').animate({'scrollTop': 0}, 500);"><i class="icmn-arrow-up"></i></a>
      -->
      <div class="cat__footer__bottom">
        <div class="cat__footer__description">
            For assistance, contact us by
            <a href="mailto:customersupport@bloodcancerunited.org?subject=Blood Cancer United Participant Center Question">email</a>
             or call us at <a href="tel:888-557-7177" class="text-nowrap">888-557-7177</a>.
        </div>
    </div>

    <about-link></about-link>
</div>

<div class="cat__footer">

    <div class="social-container">
        <h3 class="follow-us">Follow Us</h3>
        <ul class="social-list">
            <li>
                <a href="https://www.facebook.com/BloodCancerUnited" target="_blank">
                    <img alt="Facebook_BCUnited-01.png" src="https://llsorg.widen.net/content/listwxiwui/png/Facebook_BCUnited-red.png?position=c&quality=80&u=kds6i5&h=45">
                </a>
            </li>
            <li>
                <a href="https://instagram.com/bloodcancerunited/" target="_blank">
                    <img alt="Instagram_BCUnited-02.png" src="https://llsorg.widen.net/content/m5mofuc5qn/png/Instagram_BCUnited-red.png?position=c&quality=80&u=kds6i5&h=45">
                </a>
            </li>
            <li>
                <a href="https://x.com/BloodCancerUtd" target="_blank">
                    <img alt="X-logo_BCUnited-04.png" src="https://llsorg.widen.net/content/7x5b119qdn/png/X_BCUnited-red.png?position=c&quality=80&u=kds6i5&h=45">
                </a>
            </li>
            <li>
                <a href="https://www.linkedin.com/company/bloodcancerunited" target="_blank">
                    <img alt="In-logo_BCUnited-05.png" src="https://llsorg.widen.net/content/xa2udczo4b/png/In-logo_BCUnited-red.png?position=c&quality=80&u=kds6i5&h=45">
                </a>
            </li>
            <li>
                <a href="https://www.tiktok.com/@bloodcancerunited" target="_blank">
                    <img alt="tiktok_BCUnited-06.png" src="https://llsorg.widen.net/content/hcgmiuo2m4/png/tiktok_BCUnited-red.png?position=c&quality=80&u=kds6i5&h=45">
                </a>
            </li>
            <li style="padding-top: 7.5px">
                <a href="https://www.youtube.com/@BloodCancerUnited" target="_blank">
                    <img alt="YouTube_BCUnited.png" src="https://llsorg.widen.net/content/ffcwrzzrwy/png/YouTube_BCUnited-red.png?position=c&quality=80&u=kds6i5&h=30">
                </a>
            </li>
            <li>
                <a href="https://www.threads.com/@bloodcancerunited" target="_blank">
                    <img alt="Threads_BCUnited-03.png" src="https://llsorg.widen.net/content/zidoszypwh/png/Threads_BCUnited-red.png?position=c&quality=80&u=kds6i5&h=45">
                </a>
            </li>
        </ul>
    </div>
    <div class="text-container">
        <p>The Blood Cancer United mission: Cure blood cancer and improve the quality of life of all patients and their families. Blood Cancer United funds lifesaving blood cancer research around the world, provides free information and support services, and is
            the voice for all blood cancer patients seeking access to quality, affordable, coordinated care.</p>

        <p>Blood Cancer United is a 501(c)(3) organization, and all monetary donations are tax deductible to the fullest extent allowed by tax laws. Please check with your financial advisor if you have more questions. Tax Identification Number: 13-5644916</p>

        <p>© Copyright 2015-2025 Blood Cancer United. A 501(c)(3) organization. All rights reserved.</p>
    </div>
    <div class="image-container">
        <ul class="image-list">
            <li>
                <a href="https://www.charitynavigator.org/ein/135644916" target="_blank">
                    <img alt="Charity Navigator Four-Star" src="https://llsorg.widen.net/content/3tbwsuhkso/png/footer-logo-charity-navigator-four-star.webp?&amp;quality=80&amp;h=80">
                </a>
            </li>
            <li>
                <a href="https://www.guidestar.org/profile/shared/40d84a97-8b7b-4b09-9feb-b93994d2003d" target="_blank">
                    <img style="width:80px;" alt="GuideStar Platinum Transparency 2023" src="https://widgets.guidestar.org/TransparencySeal/6939026">
                </a>
            </li>
            <li>
                <img alt="Peer-to-Peer Professional Forum" src="https://llsorg.widen.net/content/r2ay58s2uy/jpeg/P2P%20US%20Top%2030%20Program.webp?&quality=80&h=80">
            </li>
        </ul>
    </div>
    <div class="link-container">
        <ul class="link-list">
            <li>
                <a href="https://bloodcancerunited.org/about-us/contact-us">Contact us</a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/6pgddxcmzw/en-es-privacy-policy" target="_blank">Privacy Policy (PDF*)</a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/rsxsfxccn7/en-es-consumer-health-data-privacy-policy" target="_blank">Consumer Health Data Privacy Policy (PDF*)</a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/7gnztnbnvs/en-es-security" target="_blank">Security (PDF*)</a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/mhdtxtktxm/en-es-copyright-policy" target="_blank">Copyright (PDF*)</a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/kq5dqfzzp7/en-es-link-policy" target="_blank">Link Policy (PDF*)</a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/ncdrljxzd8/en-es-web-site-terms-of-use" target="_blank">Website terms of use (PDF*)  </a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/hk7mxgqfmt/en-es-financial-transparency-and-independence" target="_blank">Financial transparency and independence (PDF*)</a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/2zsmnznq9n/en-es-fundraising-disclosure-policy" target="_blank">Fundraising disclosure (PDF*)</a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/lpnvfl6bxq/en-es-refund-policy" target="_blank">Refund Policy (PDF*) </a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/qwjbzk9cfn/en-es-social-media-community-guidelines" target="_blank">Community guidelines (PDF*) </a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/pttvppkd5r/en-es-accessibility-statement" target="_blank">Accessibility statement (PDF*) </a>
            </li>
            <li>
                <a href="https://llsorg.widen.net/s/b5pmvqrhmr/en-sweepstakes-rules" target="_blank">Sweepstakes Rules (PDF)</a>
            </li>
            <li>
                <a href="https://www.bloodcancers.ca/" target="_blank">LLS Canada</a>
            </li>
            <li>
                <span><sup><i>*Bilingual content/Contenido bilingüe</i></sup></span>
            </li>
        </ul>
    </div>
</div>
